<div class="d-flex">
  @for (linkData of linkList; track $index) {
    <a [href]="linkData.url" target="_blank" class="external-links-item">
      <i class="bi me-2" [class]="linkData.iconClass"></i>
      @if (linkData.name != undefined) {
        <span>{{ appTranslations[linkData.name] }}</span>
      }
    </a>
  }
</div>
